export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Hydroponic system diagrams',
  'NFT layouts',
  'DWC setups',
  'Kratky setups',
  'Drip systems',
  'Reservoir diagrams',
  'Pump and aeration layouts',
  'Root-zone visuals',
  'pH references',
  'EC references',
  'Nutrient management guides',
  'Plant spacing maps',
  'Healthy-vs-problem comparisons',
  'Growth-stage sequences',
  'Lighting diagrams',
  'Canopy management guides',
  'Crop compatibility tools',
  'Harvest-readiness references',
  'Troubleshooting trees',
  'Quick checks',
  'Maintenance tools',
  'Grower checklists',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ukAtHQUXhUpMc2STBngVWJ/Captura_de_pantalla_2026-10-16_004535.png',
    alt: 'Is it ready yet? Harvest readiness board with visual indicators for lettuce, basil, kale, tomato, pepper, cucumber and strawberry',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ubbyEfNoHEgeKaph8Y73AA/Captura_de_pantalla_2026-10-16_004512.png',
    alt: 'Small space, high output: mixed home hydroponic shelf setup with a space allocation guide by tier',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tGzN9NSTeEE5gPvgpgfJ9B/Captura_de_pantalla_2026-10-16_004449.png',
    alt: 'What do you see? Visual symptom guide — check before diagnosing yellow leaves, leaf-tip burn, stretching and wilting',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7Q6FPwUgPUpP3ZhDHCw5MF/Captura_de_pantalla_2026-10-16_004423.png',
    alt: 'Flower to fruit: strawberry flowering and fruiting timeline from bud to ripe fruit',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2xFaEWUTYVr7Yg63Acv6cU/Captura_de_pantalla_2026-10-16_004352.png',
    alt: 'Follow the plant from seed to fruit: tomato growth timeline with a general working schedule',
  },
]
